import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setInvalidToken } from "../../../../../../../../../../redux/features/main/invalidTokenSlice";
import {
  getListModuleContentLibrary,
  getListModuleSupportContentLibrary,
  streamModule,
  PostDataScorm,
  GetDataScorm
} from "../../../../../../../../../../api/repositories";

import { clearDataForm } from "../../../../../../../../../../utils";
import { datagetscorm } from "./constant";

const useActions = (
  moduleStream,
  loadingLP,
  journeyId,
  courseId,
  moduleId,
  setModuleStream,
  setIdxOpenedModule,
  hiddenClick,
  setHiddenClick,
  setLinkStream,
  setRefreshListModule,
  isMobileVersion,
  mainState,
  finishModule,
) => {
  const userId = useSelector((state) => state.notification.userId);
  const dispatch = useDispatch();
  const [idx, setIdx] = useState();
  const [currModuleStream, setCurrModuleStream] = useState();
  const [currModuleLink, setCurrModuleLink] = useState("");
  const [loadingFetchStream, setLoadingFetchStream] = useState(true);
  const [loadingSendScorm, setLoadingSendScorm] = useState(true);
  const [loadingGetScorm, setLoadingGetScorm] = useState(true);
  const [dataGetScorm, setDataGetScorm] = useState(null);


  const url = window.location.pathname;
  const arrId = url.split("/");
  console.log("parseInt(arrId[3])", parseInt(arrId[3]));
  const courseIdPosition = arrId.indexOf("course");
  const currentCourseId =
    courseIdPosition > -1 && parseInt(arrId[courseIdPosition + 1]);

  const moduleidPosition = arrId.indexOf("module");
  const currentModuleId =
    moduleidPosition > -1 && parseInt(arrId[moduleidPosition + 1]);

  const modulesupPosition = arrId.indexOf("supporting");
  const currentModuleSupId =
    modulesupPosition > -1 && parseInt(arrId[modulesupPosition + 1]);

    // fungsi send data scorm sementara
  const sendScormData = async (datascorm, scormLocalStorageKey) => {
    setLoadingSendScorm(true);

    const dataOrder = Array.isArray(datascorm) && datascorm.length === 0 ? 
      [] 
      : 
      JSON.parse(datascorm.value) == null ? 
        [] 
        : 
        orderingDataSendScorm(JSON.parse(datascorm.value))

    const payloadSend = {
      "userid": userId,
      "scormid": moduleStream.scorm_id,
      "scoid": moduleStream.sco_id,
      "timemodified": Date.now(),
      "data": dataOrder
    }
    
    console.log("SCORM SEND ",payloadSend)

    if (!Array.isArray(payloadSend.data) || payloadSend.data.length === 0) {
        setLoadingSendScorm(false)
        setTimeout(() => {
          clearDataForm(scormLocalStorageKey);
        }, 800);
      } else {
        try {
          const { data, status } = await PostDataScorm({data: payloadSend});
          dispatch(setInvalidToken(status));
          if(status === 200){
            // mainState.setMessageSnack("Success Send SCORM data");
            // mainState.setOpenedSnack(true);
            setTimeout(() => {
              clearDataForm(scormLocalStorageKey);
            }, 800);
          } else {
            // mainState.setMessageSnack("Failed Send SCORM data, Please re-sync");
            // mainState.setOpenedSnack(true);
          }
          
        } catch (err) {
          // mainState.setMessageSnack("Failed Send SCORM data, Please re-sync");
          // mainState.setOpenedSnack(true);
        } finally {
          setLoadingSendScorm(false)
        }
    }
  };


  const orderingDataSendScorm = (data) => {
    // clone biar tidak merusak array asli
    let arr = [...data];

    // 🚫 buang student_id & student_name
    arr = arr.filter(item => 
      item.element !== "cmi.core.student_id" && 
      item.element !== "cmi.core.student_name"
    );

    // helper untuk cari index element
    const findElement = (key) => arr.findIndex(item => item.element === key);

    // Pisahkan dulu berdasarkan kategori yang ada
    let lessonStatusIncomplete = arr.filter(item => item.element === "cmi.core.lesson_status" && item.value === "incomplete");
    let lessonStatusOther = arr.filter(item => item.element === "cmi.core.lesson_status" && item.value !== "incomplete");
    let coreExit = arr.filter(item => item.element === "cmi.core.exit");
    let scoreRaw = arr.filter(item => item.element === "cmi.core.score.raw");
    let sessionTime = arr.filter(item => item.element === "cmi.session_time");

    // Interactions (result & student_response) -> group by index
    let interactions = arr.filter(item => item.element.startsWith("cmi.interactions."));
    interactions.sort((a, b) => {
      // extract angka index di tengah element
      const getIndex = (el) => {
        let match = el.match(/^cmi\.interactions\.(\d+)\./);
        return match ? parseInt(match[1], 10) : Infinity;
      };
      return getIndex(a.element) - getIndex(b.element);
    });

    // Sisanya (yang tidak masuk kategori khusus)
    let others = arr.filter(item =>
      !lessonStatusIncomplete.includes(item) &&
      !lessonStatusOther.includes(item) &&
      !coreExit.includes(item) &&
      !scoreRaw.includes(item) &&
      !sessionTime.includes(item) &&
      !interactions.includes(item)
    );

    // Mulai rakit array hasil sesuai aturan
    let result = [];

    // 1. lesson_status incomplete ke paling atas
    result.push(...lessonStatusIncomplete);

    // 2. others dulu
    result.push(...others);

    // 3. interactions urut sesuai index
    result.push(...interactions);

    // 4. sessionTime, scoreRaw, lessonStatusOther, coreExit
    if (scoreRaw.length > 0) {
      result.push(...sessionTime);
      result.push(...scoreRaw);
    } 

    // lessonStatus selain incomplete → sebelum exit
    result.push(...lessonStatusOther);

    // sessionTime (jika belum masuk di atas dan ada)
    if (scoreRaw.length === 0) {
      result.push(...sessionTime);
    }

    // terakhir core.exit
    result.push(...coreExit);

    return result;
  };


  const getListCurrModuleStream = async () => {
    setLoadingFetchStream(true);

    try {
      const { data, status } = await getListModuleContentLibrary(
        parseInt(arrId[3]),
        journeyId,
        currentCourseId,
      );
      dispatch(setInvalidToken(status));
      findModule(data, currentModuleId);
    } catch (err) {
      console.log("Stream Scorm ", err.message);
    } finally {
    }
  };

  const getListCurrModuleSuppStream = async () => {
    setLoadingFetchStream(true);

    try {
      const { data, status } = await getListModuleSupportContentLibrary(
        parseInt(arrId[3]),
        journeyId,
        currentCourseId,
      );
      dispatch(setInvalidToken(status));
      findModule(data, currentModuleSupId);
    } catch (err) {
      console.log("Stream Scorm ", err.message);
    } finally {
    }
  };

  
  const getScormData = async () => {
    setLoadingGetScorm(true);
    
    const payloadGet = {
      "userid": userId,
      "scormid": moduleStream.scorm_id,
      "scoid": moduleStream.sco_id,
    }
  
    // console.log(payloadGet)
  
    try {
      // const { data, status } = datagetscorm;
      const { data, status } = await GetDataScorm({data: payloadGet});
      
      dispatch(setInvalidToken(status));
      if(status === 200){
        const onlyArrayOfObj = data.data
        setDataGetScorm(onlyArrayOfObj)
        sessionStorage.setItem("data-get-scorm",JSON.stringify(onlyArrayOfObj))
        
        // console.log(data)
        // console.log(onlyArrayOfObj)
      } else {
        setDataGetScorm(null)
      }
      
    } catch (err) {
      console.log("Error from scorm_get")
    } finally {
      setLoadingGetScorm(false)
      fetchStreamModule();
    }
  };

  const fetchStreamModule = async () => {
    setLoadingFetchStream(true);

    try {
      const { data, status, message } = await streamModule(
        moduleStream.course_id,
        moduleStream.scorm_id,
      );
      dispatch(setInvalidToken(status));
      console.log(data);
      if (status === 200) {
        setLinkStream(data);
        setCurrModuleLink(data);
        setModuleStream(moduleStream);
        setCurrModuleStream(moduleStream);
        setHiddenClick(null);
      } else {
        alert(message);
      }
    } catch (err) {
      alert(message);
    } finally {
      setLoadingFetchStream(false);
      setRefreshListModule(true);
    }
  };

  const findModule = (data, currId) => {
    const selectedModule = data.modules
      .sort((a, b) => parseInt(a.id) - parseInt(b.id))
      .find((item) => item.id === currId);

    data.modules
      .sort((a, b) => parseInt(a.id) - parseInt(b.id))
      .map((item, idx) => {
        if (item.id === currId) setIdxOpenedModule(idx + 1);
        setIdx(idx + 1);
      });

    // setLinkStream(selectedModule.stream_url)
    // setCurrModuleLink(selectedModule.stream_url)
    setModuleStream(selectedModule);
    setCurrModuleStream(selectedModule);
    setHiddenClick(null);
  };

  useEffect(() => {
    if (loadingLP === false && moduleStream === undefined)
      getListCurrModuleStream();
    if (loadingLP === false && moduleStream === undefined)
      getListCurrModuleSuppStream();
  }, [loadingLP, moduleId, hiddenClick]);

  useEffect(() => {
    if (isMobileVersion) {
      if (
        loadingLP === false &&
        moduleStream !== undefined &&
        finishModule === false
      ) {
        getScormData()
        // fetchStreamModule();
      } else {
        setLinkStream("");
        setCurrModuleLink("");
      }
    } else {
      if (loadingLP === false && moduleStream !== undefined) {
        getScormData()
        // fetchStreamModule();
      }
    }
  }, [loadingLP, moduleStream]);

  return {
    idx,
    currModuleStream,
    currModuleLink,
    loadingFetchStream,
    setCurrModuleLink,
    sendScormData,
    loadingGetScorm,
    dataGetScorm,
    loadingSendScorm
  };
};

export default useActions;
